import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=da6af1c6&scoped=true&"
import script from "./NotificationBar.vue?vue&type=script&lang=ts&"
export * from "./NotificationBar.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationBar.vue?vue&type=style&index=0&id=da6af1c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6af1c6",
  null
  
)

export default component.exports